import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import GiftCardForm from '../forms/giftCards/GiftCardForm';
import { itemForKey } from '../../lineItem/lineItemSelectors';

export const EditFormForLineItem = ({ getLineItem }) => {
    const { lineItemId } = useParams();
    return <GiftCardForm item={getLineItem(lineItemId)} />;
};

const mapStateToProps = state => ({
    getLineItem: lineItemId => itemForKey(state, lineItemId)
});

EditFormForLineItem.propTypes = {
    getLineItem: PropTypes.func.isRequired
};

export default connect(mapStateToProps)(EditFormForLineItem);
